import { DriverGroupDto } from '@cargovibe/shared-types';

interface CompleteDriverGroupCreationParams {
  group: DriverGroupDto;
  createdMessage: string;
  closeCreateDialog: () => void;
  startEditing: (group: DriverGroupDto) => void;
  showToast: (message: string) => void;
}

export function completeDriverGroupCreation({
  group,
  createdMessage,
  closeCreateDialog,
  startEditing,
  showToast,
}: CompleteDriverGroupCreationParams): void {
  closeCreateDialog();
  startEditing(group);
  showToast(createdMessage);
}
